
import { Component, Vue } from 'vue-property-decorator';
import { ReferencesType } from '@/types/Reference';

import ReferenceData from '@/references.json';

@Component
export default class References extends Vue {
  references: ReferencesType = (ReferenceData as any).references
    ? (ReferenceData as any).references
    : [];
}
